var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"sortpicker",staticClass:"sortpicker"},[_c('CbrIcon',{class:{ desc: _setup.desc, active: _setup.active, disabled: _vm.disabled },attrs:{"size":"20"}},[_vm._v(" "+_vm._s(_setup.active ? '$sortingActive' : '$sorting')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }